/**
 * @author EdenCha <eden@nurigo.net>
 */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import autoBind from 'auto-bind'
import { withRouter } from 'react-router-dom'
import deepEqual from 'fast-deep-equal/react'

// lib
import bindStateToProps from 'lib/bindStateToProps'
import bindActionCreators from 'lib/bindActionCreators'
import mapActionLog from 'lib/mapActionLog'
import proxyOverride from 'lib/proxyOverride'
import mapAsyncActions from 'lib/mapAsyncActions'

// redux modules (action)
// import { actions as rbcActions } from 'store/modules/rbc'

import Collapse from '@material-ui/core/Collapse'
import LinearProgress from '@material-ui/core/LinearProgress'

// common modules (action)
// import { actions as formActions } from 'store/modules/form'
// import { actions as tableActions } from 'store/modules/table'
// import { actions as searchActions } from 'store/modules/search'
// import { actions as uploadActions } from 'store/modules/upload'
// import { actions as popupActions } from 'store/modules/popup'
// import { actions as snackbarActions } from 'store/modules/snackbar'
// import { actions as confirmActions } from 'store/modules/confirm'
// import { actions as helpActions } from 'store/modules/help'
// import { actions as supportActions } from 'store/modules/support'

// react components & containers
// import PurplebookForeignForm from 'components/organisms/PurplebookForeignForm'

/**
 * 불러오고 있는 컴포넌트가 존재하는 경우 로딩바를 표시함
 */
class ComponentLoadingBarContainer extends Component {
  constructor(props) {
    super(props)
    // 해당 컨테이너 내의 메서드에 자동으로 this 클래스를 바인딩 합니다.
    autoBind(this)
    // 해당 컨테이너 내의 메서드 실행 시 액션로그를 남깁니다.
    mapActionLog(this)
    // HOC 사용 시 현재 컨테이너에 proxy가 props에 존재하는 경우 proxy 메서드에 this 클래스의 메서드를 대입
    proxyOverride(this)
    // 2차 인증을 사용하는 리덕스 액션이 존재하는 경우 덮어씌워 await이 정상적으로 작동하게 합니다.
    mapAsyncActions(this.props, {
      // exceptActions: { AppsActions: true }
    })
  }

  shouldComponentUpdate = (nextProps, nextState) => {
    const { loadComponents: nextLoad = [], loadedComponents: nextLoaded = [] } =
      nextProps
    const { loadComponents = [], loadedComponents = [] } = this.props
    return (
      !deepEqual(loadComponents, nextLoad) ||
      !deepEqual(loadedComponents, nextLoaded)
    )
  }

  componentDidMount = () => {
    const { ConsoleLayoutActions } = this.props
    ConsoleLayoutActions.initLoadComponent()
  }

  // hoc 사용 시 해당 부분 삭제하세요.
  componentDidUpdate = prevProps => {
    const { loadComponents: prevLoad = [], loadedComponents: prevLoaded = [] } =
      prevProps
    const {
      ConsoleLayoutActions,
      loadComponents = [],
      loadedComponents = []
    } = this.props
    const prevValue = (prevLoaded?.length / prevLoad?.length) * 100
    const value = (loadedComponents?.length / loadComponents?.length) * 100
    if (prevValue !== value && value >= 100) {
      ConsoleLayoutActions.setState({
        loadComponents: [],
        loadedComponents: []
      })
    }
  }

  render = () => {
    const { loadComponents = [], loadedComponents = [] } = this.props
    // hoc 사용 시 proxy 삭제하세요.
    // return <PurplebookForeignForm {...this.props} proxy={this} />
    const value = (loadedComponents?.length / loadComponents?.length) * 100
    return (
      <Collapse
        in={loadComponents?.length - loadedComponents?.length > 0}
        style={{
          position: 'fixed',
          top: 0,
          width: '100%',
          zIndex: 2300
        }}
      >
        <div>
          <LinearProgress variant="determinate" value={value} />
        </div>
      </Collapse>
    )
  }
}

export default withRouter(
  connect(
    bindStateToProps({
      consoleLayout: ['loadComponents', 'loadedComponents']
      // form: [{ myData: 'data.formId' }]
    }),
    bindActionCreators({
      // formActions
    })
  )(ComponentLoadingBarContainer)
)
